<template>
  <div
    class="crew-labor-record-row flex"
    :class="{ 'hover-enabled': !isTotalRow }"
  >
    <template v-if="!isTotalRow">
      <div class="date aisea-text-16-400-gray-black flex items-center z-30">
        {{ dateStr }}
      </div>
      <!-- v-if="!isBeforeToday" -->
      <div
        class="
        working-graph
        flex
        items-center
        flex-shrink-0
        relative
        aisea-text-14-400-dark-gray
      "
      >
        <div class="timeline flex flex-shrink-0">
          <!-- 時間を超過したセルにアラート: 黄・赤 -->
          <div
            v-for="(n, i) of cellNum"
            :key="`timeline-${i}`"
            class="timeline-cell text-center"
          ></div>
        </div>
        <!-- 線の入った部分 -->
        <div class="divider-div z-20 absolute flex pointer-events-none h-full">
          <div
            v-for="(n, i) of cellNum"
            :key="`divider-${i}`"
            class="timeline-cell text-center items-center divider"
          ></div>
        </div>

        <!-- 作業グラフ上の打刻 -->
        <template v-if="!isOutOfPeriod">
          <vx-tooltip-with-slot-text
            v-for="timesheet in timesheetListDisp"
            :key="timesheet.key"
            position="top"
            style="position: absolute"
            :style="timesheet.style"
          >
            <!-- ホバー時に表示するツールチップ -->
            <template v-slot:text>
              <div
                class="stamping-period z-10 aisea-text-14-400-white pl-1"
                :style="timesheet.labelStyle"
              >
                <div class="time-daytime-in">
                  開始: {{ timesheet.stampingDaytimeInText }}
                </div>
                <div class="time-daytime-out">
                  終了: {{ timesheet.stampingDaytimeOutText }}
                </div>
                <div class="work">
                  <span
                    class="rect"
                    :style="{ backgroundColor: `#${timesheet.rectBgColor}` }"
                  ></span>
                  <span class="text ml-1">{{ timesheet.label }}</span>
                </div>
              </div>
            </template>
            <!-- ホバー対象 -->
            <template v-slot:inner>
              <div
                class="stamping-period z-10"
                :style="{ backgroundColor: `#${timesheet.rectBgColor}` }"
                :data-test-txt="timesheet.key"
              ></div>
            </template>
          </vx-tooltip-with-slot-text>
        </template>
        <!-- 作業グラフ上のアラート -->
        <template v-if="!isOutOfPeriod">
          <vx-tooltip-with-slot-text
            v-for="alert in alertListDisp"
            :key="alert.key"
            position="top"
            style="position: absolute; bottom: 0px"
            :style="alert.style"
          >
            <!-- ホバー時に表示するツールチップ -->
            <template v-slot:text>
              <div
                class="alert-period z-10 aisea-text-14-400-white pl-1"
                :style="alert.labelStyle"
              >
                <div class="alert-title">
                  {{ alert.title }}
                </div>
                <div class="work">
                  <span
                    class="rect"
                    :style="{ backgroundColor: `#${alert.rectBgColor}` }"
                  ></span>
                  <span class="text ml-1"
                    >{{ alert.label }}: {{ alert.message }}</span
                  >
                </div>
              </div>
            </template>
            <!-- ホバー対象 -->
            <template v-slot:inner>
              <div
                class="alert-period z-10"
                :style="{ backgroundColor: `#${alert.rectBgColor}` }"
                :data-test-txt="alert.key"
              ></div>
            </template>
          </vx-tooltip-with-slot-text>
        </template>
      </div>

      <!-- 休日又は補償休日 -->
      <div
        v-if="!isOutOfPeriod"
        class="register-holiday flex items-center aisea-text-16-400-gray-black"
      >
        <select-holiday-cell
          :dayOff="dayOff"
          :dayOffId="dayOffId"
          :date="date"
          :enterpriseCrewId="enterpriseCrewId"
          :searchEnterpriseCrewDayOffDay="searchEnterpriseCrewDayOffDay"
          :fetchHolidaySummary="fetchHolidaySummary"
        />
      </div>

      <!-- 1日当たりの労働時間 -->
      <div
        v-if="!isOutOfPeriod"
        class="
        working-hours-per-day
        flex
        items-center
        aisea-text-16-400-gray-black
      "
      >
        {{ dailyWorkingTimeDisp }}
      </div>

      <!-- 時間外労働 -->
      <div
        v-if="!isOutOfPeriod"
        class="overtime-work flex items-center aisea-text-16-400-gray-black"
      >
        {{ dailyOvertimeDisp }}
      </div>

      <!-- 深夜残業 -->
      <div
        v-if="!isOutOfPeriod"
        class="
        working-hours-per-day
        flex
        items-center
        aisea-text-16-400-gray-black
      "
      >
        {{ lateNightOvertimeDisp }}
      </div>

      <!-- 補償休日労働 -->
      <div
        v-if="!isOutOfPeriod"
        class="
        compensation-holiday-work
        flex
        items-center
        aisea-text-16-400-gray-black
      "
      >
        {{ compensatoryOffWorkingTimeDisp }}
      </div>

      <!-- 安全臨時労働 -->
      <div
        v-if="!isOutOfPeriod"
        class="safe-temporary-work flex items-center aisea-text-16-400-gray-black"
      >
        {{ safeTemporaryWorkingTimeDisp }}
      </div>

      <!-- 作業種別 -->
      <template v-if="!isOutOfPeriod">
        <div
          v-for="(taskTime, index) in taskTimesDisp"
          :key="index"
          class="task-working flex items-center aisea-text-16-400-gray-black"
        >
          {{ taskTime.minutes }}
        </div>
      </template>

      <!-- 過去5日間以内の労働時間 -->
      <div
        v-if="!isOutOfPeriod"
        class="five-days-working flex items-center aisea-text-16-400-gray-black"
        :class="{
          warning: isFiveDaysWorkingTimeWarning,
        }"
      >
        {{ fiveDaysWorkingTimeDisp }}
      </div>

      <!-- 過去7日間以内の労働時間 -->
      <!-- Alert（赤）：72時間超 -> 4320mを超える -->
      <!-- Warning（黄）：68時間以上〜72時間以内 -> 4080m以上、4320m以内 -->
      <div
        v-if="!isOutOfPeriod"
        class="
        working-hours-per-week
        flex
        items-center
        aisea-text-16-400-gray-black
      "
        :class="{
          alert: isSevenDaysWorkingTimeAlert,
          warning:
            !isSevenDaysWorkingTimeAlert && isSevenDaysWorkingTimeWarning,
        }"
      >
        {{ sevenDaysWorkingTimeDisp }}
      </div>

      <!-- 過去28日間以内の時間外労働 -->
      <div
        v-if="!isOutOfPeriod"
        class="twenty-eight-days-overwork flex items-center aisea-text-16-400-gray-black"
        :class="{
          alert: isTwentyEightDaysOvertimeAlert,
        }"
      >
        {{ twentyEightDaysOvertimeDisp }}
      </div>

      <!-- 休息時間 -->
      <div
        v-if="!isOutOfPeriod"
        class="number-of-breaks flex items-center aisea-text-16-400-gray-black"
      >
        {{ restTimeDisp }}
      </div>

      <!-- 分割時の長い方の休息時間 -->
      <div
        v-if="!isOutOfPeriod"
        class="
        the-longer-number-of-hours-when-splitting
        flex
        items-center
        aisea-text-16-400-gray-black
      "
        :class="{ alert: isMaxOfDividedRestTimeAlert }"
      >
        {{ maxOfDividedRestTimeDisp }}
      </div>

      <!-- 補償休日が生じる1週間 -->
      <div
        v-if="!isOutOfPeriod"
        class="
        one-week-when-compensation-holidays-occur
        flex
        items-center
        aisea-text-16-400-gray-black
        justify-center
      "
      >
        {{ compensatoryOffWeekDisp }}
      </div>

      <!-- 超過時間数 -->
      <div
        v-if="!isOutOfPeriod"
        class="
        number-of-hours-exceeded
        flex
        items-center
        aisea-text-16-400-gray-black
      "
      >
        {{ compensatoryOffOvertimeDisp }}
      </div>
    </template>

    <!-- 合計行 -->
    <template v-else>
      <div
        class="date total-title-cell aisea-text-16-400-white flex items-center z-30"
      >
        合計
      </div>
      <!-- v-if="!isBeforeToday" -->
      <div
        class="
        total-cell
        working-graph
        flex
        items-center
        flex-shrink-0
        relative
        aisea-text-14-400-dark-gray
      "
      >
        <div class="timeline flex flex-shrink-0">
          <!-- 時間を超過したセルにアラート: 黄・赤 -->
          <!---->
          <div
            v-for="(n, i) of cellNum"
            :key="`timeline-${i}`"
            class="timeline-cell text-center"
          ></div>
        </div>
      </div>

      <!-- 休日又は補償休日 -->
      <div
        v-if="!isOutOfPeriod"
        class="register-holiday total-cell flex items-center aisea-text-16-400-white"
      ></div>

      <!-- 1日当たりの労働時間 -->
      <div
        v-if="!isOutOfPeriod"
        class="
        working-hours-per-day
        total-cell
        flex
        items-center
        aisea-text-16-400-white
      "
      >
        {{ dailyWorkingTimeDisp }}
      </div>

      <!-- 時間外労働 -->
      <div
        v-if="!isOutOfPeriod"
        class="overtime-work total-cell flex items-center aisea-text-16-400-white"
      >
        {{ dailyOvertimeDisp }}
      </div>

      <!-- 深夜残業 -->
      <div
        v-if="!isOutOfPeriod"
        class="
        working-hours-per-day
        total-cell
        flex
        items-center
        aisea-text-16-400-white
      "
      >
        {{ lateNightOvertimeDisp }}
      </div>

      <!-- 補償休日労働 -->
      <div
        v-if="!isOutOfPeriod"
        class="
        compensation-holiday-work
        total-cell
        flex
        items-center
        aisea-text-16-400-white
      "
      >
        {{ compensatoryOffWorkingTimeDisp }}
      </div>

      <!-- 安全臨時労働 -->
      <div
        v-if="!isOutOfPeriod"
        class="safe-temporary-work total-cell flex items-center aisea-text-16-400-white"
      >
        {{ safeTemporaryWorkingTimeDisp }}
      </div>

      <!-- 作業種別 -->
      <template v-if="!isOutOfPeriod">
        <div
          v-for="(taskTime, index) in taskTimesDisp"
          :key="index"
          class="safe-temporary-work total-cell flex items-center aisea-text-16-400-white"
        >
          {{ taskTime.minutes }}
        </div>
      </template>

      <!-- 過去5日間以内の労働時間 -->
      <div
        v-if="!isOutOfPeriod"
        class="safe-temporary-work total-cell flex items-center aisea-text-16-400-white"
      >
        -
      </div>

      <!-- 過去7日間以内の労働時間 -->
      <!-- Alert（赤）：72時間超 -> 4320mを超える -->
      <!-- Warning（黄）：68時間以上〜72時間以内 -> 4080m以上、4320m以内 -->
      <div
        v-if="!isOutOfPeriod"
        class="
        working-hours-per-week
        total-cell
        flex
        items-center
        aisea-text-16-400-white
      "
        :class="{
          alert: isSevenDaysWorkingTimeAlert,
          warning:
            !isSevenDaysWorkingTimeAlert && isSevenDaysWorkingTimeWarning,
        }"
      >
        -
      </div>

      <!-- 過去28日間以内の時間外労働時間 -->
      <div
        v-if="!isOutOfPeriod"
        class="safe-temporary-work total-cell flex items-center aisea-text-16-400-white"
      >
        -
      </div>

      <!-- 休息時間 -->
      <div
        v-if="!isOutOfPeriod"
        class="number-of-breaks total-cell flex items-center aisea-text-16-400-white"
      >
        {{ restTimeDisp }}
      </div>

      <!-- 分割時の長い方の休息時間 -->
      <div
        v-if="!isOutOfPeriod"
        class="
        the-longer-number-of-hours-when-splitting
        total-cell
        flex
        items-center
        aisea-text-16-400-white
      "
        :class="{ alert: isMaxOfDividedRestTimeAlert }"
      >
        {{ maxOfDividedRestTimeDisp }}
      </div>

      <!-- 補償休日が生じる1週間 -->
      <div
        v-if="!isOutOfPeriod"
        class="
        one-week-when-compensation-holidays-occur
        total-cell
        flex
        items-center
        aisea-text-16-400-white
        justify-center
      "
      >
        {{ compensatoryOffWeekDisp }}
      </div>

      <!-- 超過時間数 -->
      <div
        v-if="!isOutOfPeriod"
        class="
        number-of-hours-exceeded
        total-cell
        flex
        items-center
        aisea-text-16-400-white
      "
      >
        {{ compensatoryOffOvertimeDisp }}
      </div>
    </template>
  </div>
</template>

<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import VxTooltipWithSlotText from "@/layouts/components/vx-tooltip/VxTooltipWithSlotText.vue";
import SelectHolidayCell from "./SelectHolidayCell";
import moment from "moment-timezone";

const WARNING_HOUR = {
  color_hex: "FCCD41", // アラートで表示する色: FCCD41 / FF5252
  label: "注意", // アラートの種類 -> 今は注意・警告
  type: 0, // alertのtypeはenumになる想定
  message: "10時間以上〜14時間以内", // アラートで表示するメッセージ
  title: "24時間あたりの労働時間",
};
const CRITICAL_HOUR = {
  color_hex: "FF5252", // アラートで表示する色: FCCD41 / FF5252
  label: "警告", // アラートの種類 -> 今は注意・警告
  type: 1, // alertのtypeはenumになる想定
  message: "14時間超", // アラートで表示するメッセージ
  title: "24時間あたりの労働時間",
};
const DEFAULT_TIME_DISP = "-";

export default {
  name: "CrewLaborRecordRow",
  components: {
    VxTooltipWithSlotText,
    SelectHolidayCell,
  },
  mixins: [],
  props: {
    enterpriseCrewId: { type: String, require: true },
    dateStr: { type: String, default: "" },
    date: { type: String, default: "" },
    momentObj: { type: Object, default: () => null },
    cellSize: { type: Number, default: 30 },
    cellNum: { type: Number, default: 24 },
    dailyWorkingTime: { type: Number, default: null },
    compensatoryOffWorkingTime: { type: Number, default: null }, // 補償休日労働時間
    dailyOvertime: { type: Number, default: null },
    lateNightOvertime: { type: Number, default: null },
    fiveDaysWorkingTime: { type: Number, default: null },
    sevenDaysWorkingTime: { type: Number, default: null },
    twentyEightDaysOvertime: { type: Number, default: null },
    compensatoryOffWeek: { type: Number, default: null }, // 補償休日が生じる1週間
    compensatoryOffOvertime: { type: Number, default: null },
    safeTemporaryWorkingTime: { type: Number, default: null }, // 安全臨時労働
    restTime: { type: Number, default: null }, // 休憩時間数
    maxOfDividedRestTime: { type: Number, default: null }, // 分割時の長い方の休息時間
    timesheetList: { type: Array, default: () => [] },
    warningHours: { type: Array, default: () => [] },
    criticalHours: { type: Array, default: () => [] },
    dayOff: { type: Number, default: 0 },
    dayOffId: { type: String, default: null },
    searchEnterpriseCrewDayOffDay: { type: Function, default: () => {} },
    fetchHolidaySummary: { Type: Function, default: () => {} },
    startOfWorkPeriod: { Type: Function, default: null },
    endOfWorkPeriod: { Type: Function, default: null },
    taskTimes: { Type: Array, default: () => [] },

    isTotalRow: { type: Boolean, default: false }, // 合計行かどうか
    isFiveDaysWorkingTimeWarning: { type: Boolean, default: false },
    isSevenDaysWorkingTimeAlert: { type: Boolean, default: false },
    isSevenDaysWorkingTimeWarning: { type: Boolean, default: false },
    isTwentyEightDaysOvertimeAlert: { type: Boolean, default: false },
    isMaxOfDividedRestTimeAlert: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    compensatoryOffWeekDisp() {
      if (this.shoulBeHyphen) return DEFAULT_TIME_DISP;
      if (this.compensatoryOffWeek !== 1) return null;
      return "●";
    },
    // 補償休日超過時間数と補償休日が生じる1週間をハイフンとして表示すべきか判定
    // 補償休日超過時間数以外の打刻時間がハイフンなら、trueを返す
    shoulBeHyphen() {
      if (this.dailyWorkingTimeDisp !== DEFAULT_TIME_DISP) return false;
      if (this.compensatoryOffWorkingTimeDisp !== DEFAULT_TIME_DISP)
        return false;
      if (this.dailyOvertimeDisp !== DEFAULT_TIME_DISP) return false;
      if (this.sevenDaysWorkingTimeDisp !== DEFAULT_TIME_DISP) return false;
      // if(this.compensatoryOffOvertimeDisp !== DEFAULT_TIME_DISP) return false;
      if (this.safeTemporaryWorkingTimeDisp !== DEFAULT_TIME_DISP) return false;
      if (this.restTimeDisp !== DEFAULT_TIME_DISP) return false;
      if (this.maxOfDividedRestTimeDisp !== DEFAULT_TIME_DISP) return false;
      return true;
    },
    dailyWorkingTimeDisp() {
      if (!(typeof this.dailyWorkingTime === "number"))
        return DEFAULT_TIME_DISP;
      if (this.dailyWorkingTime < 0) return DEFAULT_TIME_DISP;
      if (!this.isTimeSheetExists && !this.isTotalRow) return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.dailyWorkingTime);
    },
    compensatoryOffWorkingTimeDisp() {
      if (!(typeof this.compensatoryOffWorkingTime === "number"))
        return DEFAULT_TIME_DISP;
      if (this.compensatoryOffWorkingTime < 0) return DEFAULT_TIME_DISP;
      if (!this.isTimeSheetExists && !this.isTotalRow) return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.compensatoryOffWorkingTime);
    },
    dailyOvertimeDisp() {
      if (!(typeof this.dailyOvertime === "number")) return DEFAULT_TIME_DISP;
      if (this.dailyOvertime < 0) return DEFAULT_TIME_DISP;
      if (!this.isTimeSheetExists && !this.isTotalRow) return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.dailyOvertime);
    },
    lateNightOvertimeDisp() {
      if (!(typeof this.lateNightOvertime === "number"))
        return DEFAULT_TIME_DISP;
      if (this.lateNightOvertime < 0) return DEFAULT_TIME_DISP;
      if (!this.isTimeSheetExists && !this.isTotalRow) return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.lateNightOvertime);
    },
    fiveDaysWorkingTimeDisp() {
      if (!(typeof this.fiveDaysWorkingTime === "number"))
        return DEFAULT_TIME_DISP;
      if (this.fiveDaysWorkingTime < 0) return DEFAULT_TIME_DISP;
      //if (!this.isTimeSheetExists) return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.fiveDaysWorkingTime);
    },
    sevenDaysWorkingTimeDisp() {
      if (!(typeof this.sevenDaysWorkingTime === "number"))
        return DEFAULT_TIME_DISP;
      if (this.sevenDaysWorkingTime < 0) return DEFAULT_TIME_DISP;
      //if (!this.isTimeSheetExists) return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.sevenDaysWorkingTime);
    },
    twentyEightDaysOvertimeDisp() {
      if (!(typeof this.twentyEightDaysOvertime === "number"))
        return DEFAULT_TIME_DISP;
      if (this.twentyEightDaysOvertime < 0) return DEFAULT_TIME_DISP;
      //if (!this.isTimeSheetExists) return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.twentyEightDaysOvertime);
    },
    compensatoryOffOvertimeDisp() {
      if (!(typeof this.compensatoryOffOvertime === "number"))
        return DEFAULT_TIME_DISP;
      if (this.compensatoryOffOvertime < 0) return DEFAULT_TIME_DISP;
      if (this.shoulBeHyphen) return DEFAULT_TIME_DISP;
      if (!this.isTimeSheetExists && !this.isTotalRow) return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.compensatoryOffOvertime);
    },
    safeTemporaryWorkingTimeDisp() {
      if (!(typeof this.safeTemporaryWorkingTime === "number"))
        return DEFAULT_TIME_DISP;
      if (this.safeTemporaryWorkingTime < 0) return DEFAULT_TIME_DISP;
      if (!this.isTimeSheetExists && !this.isTotalRow) return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.safeTemporaryWorkingTime);
    },
    restTimeDisp() {
      if (!(typeof this.restTime === "number")) return DEFAULT_TIME_DISP;
      if (this.restTime < 0) return DEFAULT_TIME_DISP;
      if (!this.isTimeSheetExists) return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.restTime);
    },
    taskTimesDisp() {
      if (this.taskTimes.length <= 0) return [];
      return this.taskTimes.map(taskTime => ({
        ...taskTime,
        minutes: this.getTimeFromMinutes(taskTime.minutes),
      }));
    },
    maxOfDividedRestTimeDisp() {
      if (!(typeof this.maxOfDividedRestTime === "number"))
        return DEFAULT_TIME_DISP;
      if (this.maxOfDividedRestTime < 0) return DEFAULT_TIME_DISP;
      if (!this.isTimeSheetExists) return DEFAULT_TIME_DISP;
      return this.getTimeFromMinutes(this.maxOfDividedRestTime);
    },
    timesheetListDisp() {
      return this.timesheetList
        .map(ts => this.processTimesheet(ts))
        .filter(ts => ts !== null);
    },
    warningList() {
      if (this.warningHours.length <= 0) return [];
      return this.warningHours
        .reduce((prev, cur) => {
          if (
            prev.length === 0 ||
            cur - prev[prev.length - 1].daytime_out !== 1
          ) {
            return [
              ...prev,
              {
                daytime_in: cur,
                daytime_out: cur,
              },
            ];
          }
          prev[prev.length - 1].daytime_out = cur;
          return prev;
        }, [])
        .map(wh => ({
          daytime_in: moment(this.momentObj)
            .add(wh.daytime_in, "hours")
            .startOf("hours"),
          daytime_out: moment(this.momentObj)
            .add(wh.daytime_out, "hours")
            .endOf("hours"),
          ...WARNING_HOUR,
        }));
    },
    criticalList() {
      if (this.criticalHours.length <= 0) return [];
      return this.criticalHours
        .reduce((prev, cur) => {
          if (
            prev.length === 0 ||
            cur - prev[prev.length - 1].daytime_out !== 1
          ) {
            return [
              ...prev,
              {
                daytime_in: cur,
                daytime_out: cur,
              },
            ];
          }
          prev[prev.length - 1].daytime_out = cur;
          return prev;
        }, [])
        .map(ch => ({
          daytime_in: moment(this.momentObj)
            .add(ch.daytime_in, "hours")
            .startOf("hours")
            .format(),
          daytime_out: moment(this.momentObj)
            .add(ch.daytime_out, "hours")
            .endOf("hours")
            .format(),
          ...CRITICAL_HOUR,
        }));
    },
    alertList() {
      return [...this.warningList, ...this.criticalList];
    },
    alertListDisp() {
      return this.alertList
        .map(alert => this.processAlertList(alert))
        .filter(alert => alert !== null);
    },
    timeLineLength() {
      return this.cellSize * this.cellNum || 0;
    },
    isBeforePeriod() {
      if (!this.startOfWorkPeriod) return true;
      return moment(moment(this.momentObj)).isBefore(this.startOfWorkPeriod);
    },
    isAfterPeriod() {
      if (!this.endOfWorkPeriod) return true;
      return moment(moment(this.momentObj)).isAfter(this.endOfWorkPeriod);
    },
    isOutOfPeriod() {
      return this.isBeforePeriod || this.isAfterPeriod;
    },
    isTimeSheetExists() {
      return this.timesheetList.length > 0;
    },
  },
  methods: {
    isPositiveNumber(num) {
      if (!(typeof num === "number")) return false;
      if (num < 0) return false;
      return true;
    },
    getTimelinePosition(momentObj) {
      if (!momentObj) return 0;
      return (moment(momentObj).hour() * 60 + moment(momentObj).minutes()) / 2;
    },
    getStampingPeriodWidth(startMomentObj, endMomentObj) {
      // 作業グラフのガントチャートっぽいところの長さを求める
      if (!startMomentObj) return 0;
      if (!endMomentObj) return 0;
      const width =
        this.getTimelinePosition(endMomentObj) -
        this.getTimelinePosition(startMomentObj);
      if (width <= 0) return 0;
      return width;
    },
    // 作業グラフ上のアラート情報を加工
    processAlertList(alert) {
      if (!alert) return {};
      const {
        color_hex: rectBgColor,
        daytime_in: daytimeIn,
        daytime_out: daytimeOut,
        title,
        label,
        message,
      } = alert;
      // 開始が終了よりも後はおかしいので弾く
      if (moment(daytimeOut).diff(moment(daytimeIn), "minutes") < 0) {
        return null;
      }
      const startOfTheDay = moment(this.momentObj).startOf("day");
      const endOfTheDay = moment(this.momentObj).endOf("day");

      // 24時間跨ぎをハンドリング
      const startMoment = moment(daytimeIn).isBefore(startOfTheDay)
        ? startOfTheDay
        : moment(daytimeIn);
      const endMoment = moment(daytimeOut).isAfter(endOfTheDay)
        ? endOfTheDay
        : moment(daytimeOut);

      const key = `alert-${label}-${daytimeIn}-${daytimeOut}`;
      const left = `${this.getTimelinePosition(startMoment)}px`;
      const width = `${this.getStampingPeriodWidth(startMoment, endMoment)}px`;

      return {
        key,
        style: {
          left,
          width,
        },
        labelStyle: {},
        title,
        label,
        message,
        rectBgColor,
      };
    },
    // 作業グラフ上の打刻情報を加工
    processTimesheet(timesheet) {
      if (!timesheet) return {};
      const {
        id: timesheetId,
        crew_task: crewTask,
        daytime_in: daytimeIn,
        daytime_out: daytimeOut,
      } = timesheet;
      const rectBgColor = crewTask.color_hex;
      // 開始が終了よりも後はおかしいので弾く
      if (moment(daytimeOut).diff(moment(daytimeIn), "minutes") < 0) {
        return null;
      }
      const startOfTheDay = moment(this.momentObj).startOf("day");
      const endOfTheDay = moment(this.momentObj).endOf("day");

      // 24時間跨ぎをハンドリング
      const startMoment = moment(daytimeIn).isBefore(startOfTheDay)
        ? startOfTheDay
        : moment(daytimeIn);
      const endMoment = moment(daytimeOut).isAfter(endOfTheDay)
        ? endOfTheDay
        : moment(daytimeOut);

      const key = `${timesheetId}-${daytimeIn}-${daytimeOut}`;
      const left = `${this.getTimelinePosition(startMoment)}px`;
      const width = `${this.getStampingPeriodWidth(startMoment, endMoment)}px`;
      const label = crewTask.is_custom
        ? crewTask.label
        : this.$t(`Views.Crew.LaborRecord.Tasks.${crewTask.label}`);

      return {
        key,
        style: {
          left,
          width,
        },
        labelStyle: {},
        stampingDaytimeInText: this.getStampingDaytimeText(moment(daytimeIn)),
        stampingDaytimeOutText: this.getStampingDaytimeText(moment(daytimeOut)),
        label,
        rectBgColor,
      };
    },
    getStampingDaytimeText(momentObj) {
      if (!momentObj) return "";
      return `${moment(momentObj).format("MM/DD HH:mm")}`;
    },
    getTimeFromMinutes(minutes) {
      if (typeof minutes !== "number") return null;
      const hours = String(Math.floor(minutes / 60)).padStart(2, 0);
      const restMinuites = String(minutes % 60).padStart(2, 0);
      return `${hours}:${restMinuites}`;
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
.crew-labor-record-row {
  flex-shrink: 0;
  height: 38px;
  border-bottom: 1px solid $aisea-light-gray;
  --alert-bg-color: #ff5252;
  --warning-bg-color: #ffd54f;
  > div {
    flex-shrink: 0;
    flex-grow: 0;
    height: 38px;
    border-radius: 0px;
    text-align: center;
    &:not(.working-graph) {
      min-width: 80px;
      width: 80px;
      padding: 4px 10px;
      &.date {
        padding: 4px 0px 4px 8px;
        min-width: 85px;
      }
      &.register-holiday {
        width: 180px;
        padding: 4px 0px 4px 4px;
      }
    }
    &:first-child {
      position: sticky;
      top: 0;
      left: 0;
    }
  }
  .date {
    background-color: $aisea-white;
    border-bottom: 1px solid $aisea-light-gray;
  }
  .the-longer-number-of-hours-when-splitting {
    width: 80px;
    padding: 0px, 20px, 0px, 10px;
  }
  .timeline {
    height: 100%;
  }
  .timeline-cell {
    height: 100%;
    min-width: 30px;
  }
  .stamping-period {
    height: 26px;
  }
  .alert-period {
    height: 6px;
  }
  .divider-div {
    .divider {
      height: 100%;
      border-left: solid 1px #e0e0e0;
      &:last-child {
        border-right: solid 1px #e0e0e0;
      }
    }
  }
  &.hover-enabled:hover {
    background-color: #e3e2e2;
    .date {
      color: #e0e0e0;
      background-color: $aisea-gray-black;
    }
    .timeline {
      background-color: #f2f2f2;
    }
  }
  .alert {
    background-color: var(--alert-bg-color);
    color: $aisea-pure-white;
  }
  .warning {
    background-color: var(--warning-bg-color);
    color: $aisea-pure-white;
  }
  .total-title-cell {
    background-color: $aisea-gray-black;
  }
  .total-cell {
    background-color: $aisea-gray;
  }
}
.vs-tooltip.with-text {
  .rect {
    border-radius: 2px;
    display: inline-block;
    width: 10px;
    height: 10px;
  }
}
</style>
